import { createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';

const schemesSlice = createSlice({
    name: '@schemes',
    initialState: {
        // schemes & inventory
        isTakingScreenshot: false,

        // SCHEMES
        schemeHistory: [],
        schemeSelectedRevision: null,
        scheme: null,
        schemes: [],
        schemesCount: 0,
        allSchemes: [],
        allSchemesCount: 0,
        getSchemesStatus: REQUEST_STATUS.NOT_REQUESTED,
        getSchemesError: null,
        getAllSchemesStatus: REQUEST_STATUS.NOT_REQUESTED,
        getAllSchemesError: null,
        addSchemeStatus: REQUEST_STATUS.NOT_REQUESTED,
        addSchemeError: null,
        createdSchemeId: null,
        deleteSchemeStatus: REQUEST_STATUS.NOT_REQUESTED,
        deleteSchemeError: null,
        getSchemeCertainRevisionStatus: REQUEST_STATUS.NOT_REQUESTED,
        getSchemeCertainRevisionError: null,
        trexStatus: null,
        getTrexStatus: REQUEST_STATUS.NOT_REQUESTED,
        getTrexStatusError: null,
        startTrexStatus: REQUEST_STATUS.NOT_REQUESTED,
        startTrexError: null,
        stopTrexStatus: REQUEST_STATUS.NOT_REQUESTED,
        stopTrexError: null,
        devicesAvailableForSchemes: [],
        getDevicesAvailableForSchemesStatus: REQUEST_STATUS.NOT_REQUESTED,
        getDevicesAvailableForSchemesError: null,
        devicesRequiredForScheme: null,
        getDevicesRequiredForSchemeStatus: REQUEST_STATUS.NOT_REQUESTED,
        getDevicesRequiredForSchemeError: null,
    },
    reducers: {
        setIsTakingScreenshot(state, payload) {
            state.isTakingScreenshot = payload.payload;
        },

        // PAGINATED & FILTERED SCHEMES
        getSchemesRequest(state) {
            state.getSchemesStatus = REQUEST_STATUS.LOADING;
            state.getSchemesError = null;
        },
        getSchemesSuccess(state, payload) {
            state.getSchemesStatus = REQUEST_STATUS.SUCCESS;
            state.getSchemesError = null;
            state.schemes = payload.payload.data.items || [];
            state.schemesCount = payload.payload.data.count;
        },
        getSchemesError(state, payload) {
            state.getSchemesStatus = REQUEST_STATUS.ERROR;
            state.getSchemesError = payload;
            state.schemes = [];
            state.schemesCount = 0;
        },
        getSchemesReset(state) {
            state.getSchemesStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getSchemesError = null;
            state.schemes = [];
            state.schemesCount = 0;
        },

        // ALL SCHEMES
        getAllSchemesRequest(state) {
            state.getAllSchemesStatus = REQUEST_STATUS.LOADING;
            state.getAllSchemesError = null;
        },
        getAllSchemesSuccess(state, payload) {
            state.getAllSchemesStatus = REQUEST_STATUS.SUCCESS;
            state.getAllSchemesError = null;
            state.allSchemes = payload.payload.data.items || [];
            state.allSchemesCount = payload.payload.data.count;
        },
        getAllSchemesError(state, payload) {
            state.getAllSchemesStatus = REQUEST_STATUS.ERROR;
            state.getAllSchemesError = payload;
            state.allSchemes = [];
            state.allSchemesCount = 0;
        },
        getAllSchemesReset(state) {
            state.getAllSchemesStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getAllSchemesError = null;
            state.allSchemes = [];
            state.allSchemesCount = 0;
        },

        getSchemeByIdRequest(state) {
            state.getSchemeByIdStatus = REQUEST_STATUS.LOADING;
            state.getSchemeByIdError = null;
            state.scheme = null;
        },
        getSchemeByIdSuccess(state, payload) {
            const responseData = payload.payload.data;
            state.getSchemeByIdStatus = REQUEST_STATUS.SUCCESS;
            state.getSchemeByIdError = null;
            state.scheme = responseData;
        },
        getSchemeByIdError(state, payload) {
            state.getSchemeByIdStatus = REQUEST_STATUS.ERROR;
            state.getSchemeByIdError = payload;
            state.scheme = null;
        },
        getSchemeByIdReset(state) {
            state.getSchemeByIdStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getSchemeByIdError = null;
            state.scheme = null;
        },

        addSchemeRequest(state) {
            state.addSchemeStatus = REQUEST_STATUS.LOADING;
            state.addSchemeError = null;
            state.createdSchemeId = null;
        },
        addSchemeSuccess(state, action) {
            state.addSchemeStatus = REQUEST_STATUS.SUCCESS;
            state.addSchemeError = null;
            state.createdSchemeId = action.payload.pk;
        },
        addSchemeError(state, payload) {
            state.addSchemeStatus = REQUEST_STATUS.ERROR;
            state.addSchemeError = payload;
            state.createdSchemeId = null;
        },
        addSchemeReset(state) {
            state.addSchemeStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.addSchemeError = null;
            state.createdSchemeId = null;
        },

        editSchemeRequest(state) {
            state.editSchemeStatus = REQUEST_STATUS.LOADING;
            state.editSchemeError = null;
        },
        editSchemeSuccess(state, action) {
            state.editSchemeStatus = REQUEST_STATUS.SUCCESS;
            state.editSchemeError = null;
            state.scheme = action.payload;
        },
        editSchemeError(state, payload) {
            state.editSchemeStatus = REQUEST_STATUS.ERROR;
            state.editSchemeError = payload;
        },
        editSchemeReset(state) {
            state.editSchemeStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.editSchemeError = null;
        },

        deleteSchemeRequest(state) {
            state.deleteSchemeStatus = REQUEST_STATUS.LOADING;
            state.deleteSchemeError = null;
        },
        deleteSchemeSuccess(state) {
            state.deleteSchemeStatus = REQUEST_STATUS.SUCCESS;
            state.deleteSchemeError = null;
        },
        deleteSchemeError(state, payload) {
            state.deleteSchemeStatus = REQUEST_STATUS.ERROR;
            state.deleteSchemeError = payload;
        },
        deleteSchemeReset(state) {
            state.deleteSchemeStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.deleteSchemeError = null;
        },
        getTrexStatusRequest(state) {
            state.getTrexStatus = REQUEST_STATUS.LOADING;
            state.getTrexStatusError = null;
        },
        getTrexStatusSuccess(state, action) {
            state.getTrexStatus = REQUEST_STATUS.SUCCESS;
            state.getTrexStatusError = null;
            state.trexStatus = action.payload.data;
        },
        getTrexStatusError(state, action) {
            state.getTrexStatus = REQUEST_STATUS.ERROR;
            state.getTrexStatusError = action.payload;
        },
        getTrexStatusReset(state) {
            state.getTrexStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getTrexStatusError = null;
        },
        startTrexRequest(state) {
            state.startTrexStatus = REQUEST_STATUS.LOADING;
            state.startTrexError = null;
        },
        startTrexSuccess(state, action) {
            state.startTrexStatus = REQUEST_STATUS.SUCCESS;
            state.startTrexError = null;
            state.trexStatus = action.payload.data;
        },
        startTrexError(state, action) {
            state.startTrexStatus = REQUEST_STATUS.ERROR;
            state.startTrexError = action.payload;
        },
        startTrexReset(state) {
            state.startTrexStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.startTrexError = null;
        },
        stopTrexRequest(state) {
            state.stopTrexStatus = REQUEST_STATUS.LOADING;
            state.stopTrexError = null;
        },
        stopTrexSuccess(state, action) {
            state.stopTrexStatus = REQUEST_STATUS.SUCCESS;
            state.stopTrexError = null;
            state.trexStatus = action.payload.data;
        },
        stopTrexError(state, action) {
            state.stopTrexStatus = REQUEST_STATUS.ERROR;
            state.stopTrexError = action.payload;
        },
        stopTrexReset(state) {
            state.stopTrexStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.stopTrexError = null;
        },

        getDevicesAvailableForSchemesRequest(state, action) {
            state.getDevicesAvailableForSchemesStatus = REQUEST_STATUS.LOADING;
            state.getDevicesForSchemeError = null;
            state.devicesAvailableForSchemes = [];
        },
        getDevicesAvailableForSchemesSuccess(state, action) {
            state.getDevicesAvailableForSchemesStatus = REQUEST_STATUS.SUCCESS;
            state.getDevicesAvailableForSchemesError = null;
            // const mockData = action.payload.data?.dut
            //     ? action.payload.data.dut.map((item) => ({
            //           ...item,
            //           zone_connections: {
            //               port0: 'mgmt',
            //               port1: 'lan',
            //               port2: 'wan',
            //           },
            //       }))
            //     : [];
            state.devicesAvailableForSchemes = action.payload.data?.dut || [];
            // state.devicesAvailableForSchemes = mockData;
        },
        getDevicesAvailableForSchemesError(state, action) {
            state.getDevicesAvailableForSchemesStatus = REQUEST_STATUS.ERROR;
            state.getDevicesForSchemeError = action;
            state.devicesAvailableForSchemes = [];
        },
        getDevicesAvailableForSchemesReset(state) {
            state.getDevicesAvailableForSchemesStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getDevicesForSchemeError = null;
            state.devicesAvailableForSchemes = [];
        },
        getDevicesRequiredForSchemeRequest(state, _action) {
            state.getDevicesRequiredForSchemeStatus = REQUEST_STATUS.LOADING;
            state.getDevicesRequiredForSchemeError = null;
            state.devicesRequiredForScheme = null;
        },
        getDevicesRequiredForSchemeSuccess(state, action) {
            state.getDevicesRequiredForSchemeStatus = REQUEST_STATUS.SUCCESS;
            state.getDevicesRequiredForSchemeError = null;
            state.devicesRequiredForScheme = action.payload.data || null;
        },
        getDevicesRequiredForSchemeError(state, action) {
            state.getDevicesRequiredForSchemeStatus = REQUEST_STATUS.ERROR;
            state.getDevicesRequiredForSchemeError = action;
            state.devicesRequiredForScheme = null;
        },
        getDevicesRequiredForSchemeReset(state) {
            state.getDevicesRequiredForSchemeStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getDevicesRequiredForSchemeError = null;
            state.devicesRequiredForScheme = null;
        },
    },
});

export default schemesSlice.reducer;

export const {
    setIsTakingScreenshot,
    getSchemesRequest,
    getSchemesSuccess,
    getSchemesError,
    getSchemesReset,
    getAllSchemesRequest,
    getAllSchemesSuccess,
    getAllSchemesError,
    getAllSchemesReset,
    getSchemeByIdRequest,
    getSchemeByIdSuccess,
    getSchemeByIdError,
    getSchemeByIdReset,
    addSchemeRequest,
    addSchemeSuccess,
    addSchemeError,
    addSchemeReset,
    editSchemeRequest,
    editSchemeSuccess,
    editSchemeError,
    editSchemeReset,
    deleteSchemeRequest,
    deleteSchemeSuccess,
    deleteSchemeError,
    deleteSchemeReset,
    getTrexStatusRequest,
    getTrexStatusSuccess,
    getTrexStatusError,
    getTrexStatusReset,
    startTrexRequest,
    startTrexSuccess,
    startTrexError,
    startTrexReset,
    stopTrexRequest,
    stopTrexSuccess,
    stopTrexError,
    stopTrexReset,
    getDevicesAvailableForSchemesRequest,
    getDevicesAvailableForSchemesSuccess,
    getDevicesAvailableForSchemesError,
    getDevicesRequiredForSchemeRequest,
    getDevicesRequiredForSchemeSuccess,
    getDevicesRequiredForSchemeError,
} = schemesSlice.actions;
